const SiteAdminServerErrorTemplate = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="flex items-center pt-8">
        <div className="px-4 text-lg text-gray-400 border-r border-gray-300 tracking-wider">
          500
        </div>

        <div className="ml-4 text-lg text-gray-400 uppercase tracking-wider">
          Server Error
        </div>
      </div>
    </div>
  );
};

export default SiteAdminServerErrorTemplate;
